import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EditProfileComponent } from './components/edit-profile/edit-profile.component';
import { CommonModalComponent } from './components/common-modal/common-modal.component';
import { CommonModule } from '@angular/common';
import { TranslationModule } from './modules/translation.module';
import { NoRouteComponent } from './modules/shared/components/no-route/no-route.component';
import { SpinnerComponentComponent } from './modules/shared/components/spinner-component/spinner-component.component';
import { LegalPageComponent } from './modules/shared/pages/legal-page/legal-page.component';
import { PrivacyPageComponent } from './modules/shared/pages/privacy-page/privacy-page.component';
import { ProviderPageComponent } from './modules/shared/pages/provider-page/provider-page.component';
import { SafePipe } from './pipes/safe.pipe';
import { CustomToastComponent } from './modules/shared/components/toast/custom-toast.component';
import { GenericLoginPageComponent } from './components/generic-login-page/generic-login-page.component';
import { RaceShareErrorHandlingComponent } from './modules/shared/components/race-share-error-handling/race-share-error-handling.component';
import { LightboxComponent } from './modules/stories/components/lightbox/lightbox.component';
import { WorkbenchModule } from '@workbench/angular';
import { CustomVideoComponent } from './modules/stories/components/custom-video/custom-video.component';
import { RaceShareSuccessHandlingComponent } from './modules/shared/components/race-share-success-handling/race-share-success-handling.component';
import { NotificationComponent } from './modules/shared/components/notification/notification.component';
@NgModule({
    declarations: [EditProfileComponent,
    CommonModalComponent,
    NoRouteComponent,
    SpinnerComponentComponent,
    PrivacyPageComponent,
    ProviderPageComponent,
    LegalPageComponent,
    SafePipe,
    CustomToastComponent,
    RaceShareErrorHandlingComponent,
    RaceShareSuccessHandlingComponent,
    GenericLoginPageComponent,
    LightboxComponent,
    CustomVideoComponent,
    NotificationComponent
    ],
    imports: [CommonModule,  TranslationModule, ReactiveFormsModule, FormsModule, WorkbenchModule],
    exports: [EditProfileComponent, CommonModalComponent, NoRouteComponent, RaceShareErrorHandlingComponent, SpinnerComponentComponent, SafePipe, CustomToastComponent, TranslationModule, GenericLoginPageComponent, LightboxComponent, RaceShareSuccessHandlingComponent, NotificationComponent,CustomVideoComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  })
  export class SharedModule { }
